'use strict';

require("core-js/modules/es6.object.assign");

var engines = require('./engines');

var utils = require('./utils');

module.exports = function (options) {
  var opts = Object.assign({}, options); // ensure that delimiters are an array

  opts.delimiters = utils.arrayify(opts.delims || opts.delimiters || '---');

  if (opts.delimiters.length === 1) {
    opts.delimiters.push(opts.delimiters[0]);
  }

  opts.language = (opts.language || opts.lang || 'yaml').toLowerCase();
  opts.engines = Object.assign({}, engines, opts.parsers, opts.engines);
  return opts;
};